import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance, createRef } from 'intact-vue';
import { useReceive } from '../../hooks/useReceive';
export function useTooltip(showValue) {
  var instance = useInstance();
  var firstTooltipRef = createRef();
  var secondTooltipRef = createRef();
  var defaultTooltipProps = {
    container: function container(parentDom) {
      return parentDom;
    },
    hoverable: true,
    always: instance.get('always')
  };
  var tooltipProps = defaultTooltipProps;
  useReceive(['always', 'tooltipProps'], function () {
    var _instance$get = instance.get(),
      always = _instance$get.always,
      props = _instance$get.tooltipProps;
    tooltipProps = _extends({}, defaultTooltipProps, {
      always: always
    }, props);
    if (always) {
      tooltipProps.value = true;
    }
  });
  instance.on('$changed:value', function () {
    if (instance.get('always')) {
      show();
    }
  });
  function getTooltipProps() {
    return tooltipProps;
  }
  function show() {
    if (!instance.get('showTooltip')) return;
    var first = firstTooltipRef.value;
    var second = secondTooltipRef.value;
    first.show();
    first.position();
    if (second) {
      second.show();
      second.position();
    }
  }
  function hide() {
    firstTooltipRef.value.hide(false);
    var second = secondTooltipRef.value;
    if (second) {
      second.hide(false);
    }
  }
  return {
    firstTooltipRef: firstTooltipRef,
    secondTooltipRef: secondTooltipRef,
    getTooltipProps: getTooltipProps,
    show: show,
    hide: hide
  };
}